export const extractHashtags = (description: string) => {
  const regex = /#(\w+)/g;
  const hashtags = description?.match(regex);
  return hashtags || [description];
}
